import React from "react";

const Divider = ({ show }) => (
  <div className={`divider ${show ? "show" : ""}`} />
);

export default Divider;
